import React, {useEffect, useState} from "react";
import "./Skills.scss";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import {illustration, skillsSection} from "../../portfolio";
import Reveal from "../../components/reveal/Reveal";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";

const skillIcons = [
  "fas fa-layer-group",
  "fas fa-server",
  "fas fa-mobile-alt",
  "fas fa-cloud",
  "fas fa-database",
  "fas fa-cogs"
];

export default function Skills() {
  const [lottieData, setLottieData] = useState(null);

  useEffect(() => {
    if (!illustration.animated) return undefined;
    let cancelled = false;
    import("../../assets/lottie/codingPerson").then(mod => {
      if (!cancelled) setLottieData(mod.default);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!skillsSection.display) {
    return null;
  }
  return (
    <div className="main" id="skills">
      <Reveal direction="up">
        <header className="skills-header">
          <span className="section-eyebrow">Expertise</span>
          <h1 className="section-heading">{skillsSection.title}</h1>
          <p className="section-subtitle">{skillsSection.subTitle}</p>
        </header>
      </Reveal>

      <div className="skills-layout">
        <Reveal direction="left">
          <div className="skills-lottie-wrap">
            <div className="lottie-frame">
              {illustration.animated && lottieData ? (
                <DisplayLottie animationData={lottieData} speed={2} />
              ) : illustration.animated ? (
                <div className="lottie-skeleton" aria-hidden="true" />
              ) : (
                <img
                  alt="Developer working"
                  src={require("../../assets/images/developerActivity.svg")}
                />
              )}
            </div>
            <div className="skills-float-notes" aria-hidden="true">
              <span className="skills-float-note skills-float-note-1">
                Nuxt & Vue
              </span>
              <span className="skills-float-note skills-float-note-2">
                Stripe Ready
              </span>
              <span className="skills-float-note skills-float-note-3">
                AWS & CI/CD
              </span>
            </div>
            <div className="skills-mobile-chips" aria-hidden="true">
              <span className="skills-mobile-chip" style={{animationDelay: "0.1s"}}>
                Nuxt & Vue
              </span>
              <span className="skills-mobile-chip" style={{animationDelay: "0.18s"}}>
                Stripe Ready
              </span>
              <span className="skills-mobile-chip" style={{animationDelay: "0.26s"}}>
                AWS & CI/CD
              </span>
            </div>
          </div>
        </Reveal>

        <div className="skills-content">
          <Reveal direction="up" delay={80}>
            <SoftwareSkill />
          </Reveal>

          <Reveal direction="up" delay={140}>
            <ul className="skills-list">
              {skillsSection.skills.map((skill, i) => (
                <li
                  key={i}
                  className="skills-list-item"
                  style={{"--i": i}}
                >
                  <span className="skills-list-icon" aria-hidden="true">
                    <i className={skillIcons[i % skillIcons.length]} />
                  </span>
                  <span>{skill}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
